(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amk-invoice-request"]) return;
  try {
    
(() => {
  const form = document.getElementById('AmkInvoiceRequest');
  if (!form) return;
  const key = 'amk-invoice-request-pending';
  const success = form.querySelector('[data-amk-invoice-success]');
  const order = form.querySelector('[name="contact[Bestellnummer]"]');
  const status = document.getElementById('amk-invoice-status');
  if (success) {
    try { sessionStorage.removeItem(key); } catch {}
    history.replaceState(null, '', location.pathname);
    return;
  }
  if (!order) return;
  const params = new URLSearchParams(location.hash.slice(1));
  const reference = params.get('bestellung') || '';
  const valid = reference.length > 0 && reference.length <= 80 && /^[\p{L}\p{N} /#._-]+$/u.test(reference);
  if (valid) order.value = reference;
  const body = form.querySelector('[name="contact[body]"]');
  const test = params.get('test') === '1';
  function prepare() {
    body.value = (test ? 'TECHNISCHER TEST – bitte keine Rechnung versenden.\n\n' : '') +
      'Bitte senden Sie mir die Rechnung zur Bestellung ' + order.value + ' erneut per E-Mail.\n' +
      'Anfrage aus dem AMK Kundenkonto. Bitte vor dem Versand die Bestellnummer und die hinterlegte Rechnungsadresse prüfen.\n' +
      'Bitte die Rechnung ausschließlich an die in der Bestellung hinterlegte E-Mail-Adresse senden.';
  }
  form.addEventListener('submit', prepare);
  if (!valid || form.querySelector('.errors')) {
    status.textContent = 'Bitte prüfen Sie die Bestellnummer und senden Sie Ihre Anfrage.';
    return;
  }
  let submitted = false;
  function send() {
    if (submitted) return;
    submitted = true;
    prepare();
    try { sessionStorage.setItem(key, order.value); } catch {}
    status.textContent = 'Ihre Anfrage wird gesendet …';
    history.replaceState(null, '', location.pathname + location.search);
    form.requestSubmit();
  }
  // Let Shopify apply the merchant's configured spam protection on normal submission.
  send();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amk-order-request"]) return;
  try {
    
(() => {
  const form = document.getElementById('AmkOrderRequest');
  if (!form) return;
  if (form.querySelector('[data-amk-request-success]')) {
    history.replaceState(null, '', location.pathname);
    return;
  }
  const order = form.querySelector('[name="contact[Bestellnummer]"]');
  if (!order) return;
  const kind = form.closest('[data-amk-request-kind]').dataset.amkRequestKind;
  const params = new URLSearchParams(location.hash.slice(1));
  const reference = params.get('bestellung') || '';
  const message = (params.get('nachricht') || '').trim();
  const validReference = reference.length > 0 && reference.length <= 80 && /^[\p{L}\p{N} /#._-]+$/u.test(reference);
  const validMessage = message.length > 0 && message.length <= 5000;
  const body = form.querySelector('[name="contact[body]"]');
  const status = document.getElementById('amk-request-status');
  if (validReference) order.value = reference;
  const testPrefix = params.get('test') === '1' ? 'TECHNISCHER TEST – bitte keine Bestellung ändern.\n\n' : '';
  if (kind === 'cancellation') {
    body.value = testPrefix + 'Bitte prüfen Sie, ob die Bestellung ' + reference + ' noch storniert werden kann.\nDie Anfrage allein ist keine bestätigte Stornierung. Bitte vor Änderungen den aktuellen Versandstatus in BaseLinker und Shopify prüfen und dem Kunden antworten.';
  } else if (validMessage) {
    body.value = testPrefix + message;
  }
  if (!validReference || (kind !== 'cancellation' && !validMessage) || form.querySelector('.errors')) {
    status.textContent = 'Bitte prüfen Sie Ihre Angaben und senden Sie Ihre Anfrage.';
    return;
  }
  let submitted = false;
  function send() {
    if (submitted) return;
    submitted = true;
    status.textContent = 'Ihre Anfrage wird gesendet …';
    history.replaceState(null, '', location.pathname + location.search);
    // Preserve native validation and submit listeners, including Shopify protection.
    form.requestSubmit();
  }
  // Use the native Shopify form and honor the merchant's spam-protection settings.
  // Any platform-required challenge is still handled by Shopify's normal submit flow.
  send();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
